import EditAssetPackModal from './EditAssetPackModal.container'

export default EditAssetPackModal
